import React from "react";
import API1 from "../../../assets/images/api1.png";
import API2 from "../../../assets/images/api2.png";

// /document-api?i=connect-api
export default function ConnectApi() {
  return (
    <>
              <h5 className="fw-bold">
                1. Request a Certificate for API Access
              </h5>
              <p>
                Visit the provided website and submit a request for a
                Certificate used to connect to the API.
              </p>
              <p>
                Before requesting the certificate, you must send your IP address
                to the system administrator so that it can be whitelisted.
              </p>
              <div className="w-100 rounded-3 px-3 py-2 my-3 bg-light">
                <img
                  alt="API"
                  src={API1}
                  className="w-100 my-3"
                  style={{ maxWidth: 700 }}
                />
              </div>
              <div className="fw-bold mb-2">📝 Important Notes:</div>
              <p>
                If you need to add a new IP address later, you must re-request a
                certificate for that IP.
              </p>
              <p>
                Each certificate is valid from the day it is issued until June
                30. A certificate requested less than 30 days before June 30 is
                valid until June 30 of the following year.
              </p>
              <h5 className="fw-bold">2. Download the Certificate</h5>
              <p>
                After requesting, a password-protected <b>certificate.zip</b>{" "}
                downloads immediately from the Connect API page.
              </p>
              <p>
                🔒 The password to unzip the file is sent to your registered
                email.
              </p>
              <div className="w-100 rounded-3 px-3 py-2 my-3 bg-light">
                <img
                  alt="API"
                  src={API2}
                  className="w-100 my-3"
                  style={{ maxWidth: 700 }}
                />
              </div>
              <h5 className="fw-bold">3. Extract the Certificate Files</h5>
              <p>Once extracted, you will obtain two files:</p>
              <p>certificate.pem (The public certificate)</p>
              <p>private.key (The private key)</p>
              <h5 className="fw-bold">4. Add Certificate to Your Project</h5>
              Place the certificate files in a folder named cert at the root
              level of your project, like so:
              <div className="w-100 rounded-3 px-3 py-2 my-3 bg-light">
                <pre>
                  PROJECT
                  <br /> ├── cert
                  <br /> │ ├── certificate.pem
                  <br /> │ └── private.key
                  <br /> ├── src
                  <br /> ├── package.json
                  <br /> ...
                </pre>
              </div>
              <h5 className="fw-bold">5. Endpoints, Headers and Token</h5>
              <ul>
                <li>
                  Base path: <code>{`{{url}}/api/opay/v1.0/partner`}</code>.
                  Request a token with{" "}
                  <code>{`POST {{url}}/api/oauth/v1.0/partner/token`}</code>.
                </li>
                <li>
                  Every request needs the headers <b>client_id</b>,{" "}
                  <b>client_secret</b>, <b>client_ref_id</b>,{" "}
                  <b>x-apigw-api-id</b>, <b>x-timestamp</b> and{" "}
                  <b>x-signature</b>. All requests except the token request also
                  need <b>Authorization: Bearer &lt;token&gt;</b>.
                </li>
                <li>
                  Tokens are valid for <b>30 minutes</b> (<b>token_expires</b>,
                  format YYYY-MM-DD HH:mm:ss, Asia/Bangkok time).
                </li>
                <li>
                  Token requests are limited to <b>100 requests per 5 minutes per
                  IP</b>. Above that you receive HTTP 429 (P-4029).
                </li>
                <li>
                  The calling IP must be included in your certificate and in your
                  IP whitelist.
                </li>
              </ul>
    </>
  );
}
